/**
 * InventoryOverlay — HUD element (extracted from PixiHUDRenderer.js in Phase 3D).
 *
 * create(hud) builds the PIXI objects into hud.elements.inventoryOverlay,
 * position(hud) lays them out for hud.screenWidth/Height, update(hud, …) redraws
 * from game state. `hud` is the PixiHUDRenderer coordinator: it owns
 * hudContainer, elements, screen size, _createText() and send().
 */
import * as PIXI from 'pixi.js';

/**
 * Create inventory overlay (TAB screen)
 */
export function create(hud) {
  const container = new PIXI.Container();
  container.visible = false; // Hidden by default
  container.zIndex = 100; // Below inventory slots (which will be 200)
  
  // Black semi-transparent overlay
  const overlay = new PIXI.Graphics();
  overlay.rect(0, 0, hud.screenWidth, hud.screenHeight);
  overlay.fill({ color: 0x000000, alpha: 0.7 });
  container.addChild(overlay);

  // Instruction text: "Press TAB to close"
  const instructionText = hud._createText('Press TAB to close inventory', 24, 0xffffff, true);
  instructionText.anchor.set(0.5, 0);
  instructionText.x = hud.screenWidth / 2;
  instructionText.y = 50;
  container.addChild(instructionText);

  // Add to HUD container and enable sorting
  hud.hudContainer.addChild(container);
  hud.hudContainer.sortableChildren = true;

  hud.elements.inventoryOverlay = { container, overlay, instructionText };
}
